module.exports = __webpack_public_path__ + "img/ois-avatar.80050842.png";